import { authenticatedApiPost } from './apiWithAuth';

export interface SummarizeRequest {
  messages: Array<{ role: 'user' | 'assistant'; content: string }>;
  summaryType?: 'conversation' | 'message';
}

export interface SummarizeResponse {
  summary: string;
  topic?: string;
}

export async function summarizeConversation(
  messages: Array<{ sender: 'user' | 'ai'; text: string }>,
  summaryType: 'conversation' = 'conversation'
): Promise<SummarizeResponse> {
  try {
    // Convert from our format to API format
    const apiMessages = messages.map(msg => ({
      role: msg.sender === 'user' ? 'user' as const : 'assistant' as const,
      content: msg.text
    }));

    const response = await authenticatedApiPost('SUMMARIZE', {
      messages: apiMessages,
      summaryType
    });

    if (!response.ok) {
      throw new Error(`Summarize API error: ${response.status}`);
    }

    const data = await response.json();
    return {
      summary: data.summary || 'Summary not available',
      topic: data.topic
    };
  } catch (error) {
    console.error('Error calling summarize endpoint:', error);
    return {
      summary: 'Error generating summary. Please try again.',
      topic: undefined
    };
  }
} 